import { BlockMenuItem } from "./BlockMenu";
import { commandView } from "./utils";
import {ipcInvoke} from '@/common/ipc'
import {
  createCopyLink,
  formatDate,
  generateUUID2,
  getFileNameExt,
  getImagePathWithTheme,
  imgPathPerfix,
  isDarkMode
} from "@/utils";
import React from "react";
import {t} from "i18next";
import { Modal, Input, message } from 'antd';
import {postMessage} from "@/common/event";
import {EVENT_SHOW_COMMON_INPUT, KEY_FILE_DIR} from "@/Const";
import Global from "@/global";
import {insertDeeplinkToCard, insertFileToLibrary, isInSingleFloatWindow} from "@/Utility";
import { TemplateSelector } from '@/components/TemplateDialog/TemplateSelector';


const getToday = () => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  const Today = new Date();
  return Today.toLocaleDateString('en-US', options);
}
const getTomorrow = () => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  const Tomorrow = new Date();
  Tomorrow.setDate(new Date().getDate() + 1);
  return Tomorrow.toLocaleDateString('en-US', options);
}
const getNow = ()=>{
  const now = new Date();
  let nHour = now.getHours();
  let nMin = now.getMinutes();
  let szM = "AM";
  if (nHour >= 12){
    szM = "PM";
    if (nHour > 12){
      nHour -= 12;
    }
  }
  if (nHour == 0){
    nHour = 12;
  }

  let szHour = nHour+'';
  if (szHour.length == 1){
    szHour = '0'+szHour;
  }
  let szMin = nMin + '';
  if (szMin.length == 1){
    szMin = '0'+szMin;
  }

  return szHour + ":"+szMin + " "+szM;
  // return formatDate(Date.now(),'hh:mm')
}


const insertIndentedBulletList=(editor,from,indent)=>{
  const state = editor.state;
  const dispatch = editor.view.dispatch;
  const { schema, tr, selection } = state;
  const rangeFrom = from;

  const resolvedPos = state.doc.resolve(rangeFrom);
  const nodeStart = resolvedPos.start(resolvedPos.depth);
  const nodeEnd = resolvedPos.end(resolvedPos.depth);

  const currentNode = resolvedPos.node();
  const parentNode = resolvedPos.node(resolvedPos.depth - 1);

  // 获取上一个相邻节点
  let lastNodeResolved;
  try {
    lastNodeResolved = state.doc.resolve(nodeStart - 2);
  } catch (error) {
    lastNodeResolved = undefined;
  }

  const lastNode = lastNodeResolved?.node();
  // 特殊情况：缩进 + 前面是 list，就做结构替换
  if (
      currentNode.type.name === 'paragraph' && indent &&
      indent >= 1 &&
      lastNodeResolved &&
      ['bulletList', 'orderedList', 'taskList'].includes(lastNode?.type.name)
  ) {
    let lastNodeJson = lastNode.toJSON();
    const uuid=crypto.randomUUID()

    // 构建新的子 list（bulletList -> listItem -> paragraph）
    const listItem = schema.nodes.listItem.create({}, schema.nodes.paragraph.create({ id:uuid }));
    const bulletList = schema.nodes.bulletList.create({}, [listItem]);

    const lastNodeStart = lastNodeResolved.start(lastNodeResolved.depth);
    let firstLevelLastListItem = lastNodeJson.content[lastNodeJson.content.length - 1];

    firstLevelLastListItem.content.push(bulletList.toJSON());
    lastNodeJson.content[lastNodeJson.content.length - 1] = firstLevelLastListItem;

    const newNode = schema.nodeFromJSON(lastNodeJson);
    tr.replaceRangeWith(lastNodeStart, nodeEnd, newNode);
    editor.view.dom.blur();
    dispatch?.(tr);
    setTimeout(() => {
      const selectNodeNP = editor.$doc.querySelectorAll('paragraph', { id: uuid })[0]
      editor.commands.focus(selectNodeNP.from)
    }, 10);
    return true;
  }

  // 默认插入 bulletList 的行为
  return editor.commands.insertContent({
    type: 'bulletList',
    content: [
      {
        type: 'listItem',
        content: [
          {
            type: 'paragraph',
          },
        ],
      },
    ],
  });
}
const insertIndentedOrderedList=(editor,from,indent)=>{
  try {
    const state = editor.state;
    const dispatch = editor.view.dispatch;
    const { schema, tr, selection } = state;
    const rangeFrom = from;

    const resolvedPos = state.doc.resolve(rangeFrom);
    const nodeStart = resolvedPos.start(resolvedPos.depth);
    const nodeEnd = resolvedPos.end(resolvedPos.depth);

    const currentNode = resolvedPos.node();
    const parentNode = resolvedPos.node(resolvedPos.depth - 1);

    // 获取上一个相邻节点
    let lastNodeResolved;
    try {
      lastNodeResolved = state.doc.resolve(nodeStart - 2);
    } catch (error) {
      lastNodeResolved = undefined;
    }

    const lastNode = lastNodeResolved?.node();
    // 特殊情况：缩进 + 前面是 list，就做结构替换
    if (
        currentNode.type.name === 'paragraph' && indent &&
        indent >= 1 &&
        lastNodeResolved &&
        ['bulletList', 'orderedList', 'taskList'].includes(lastNode?.type.name)
    ) {
      let lastNodeJson = lastNode.toJSON();
      const uuid=crypto.randomUUID()

      // 构建新的子 list（bulletList -> listItem -> paragraph）
      const listItem = schema.nodes.listItem.create({}, schema.nodes.paragraph.create({ id:uuid }));
      const orderedList = schema.nodes.orderedList.create({}, [listItem]);

      const lastNodeStart = lastNodeResolved.start(lastNodeResolved.depth);
      let firstLevelLastListItem = lastNodeJson.content[lastNodeJson.content.length - 1];

      firstLevelLastListItem.content.push(orderedList.toJSON());
      lastNodeJson.content[lastNodeJson.content.length - 1] = firstLevelLastListItem;

      const newNode = schema.nodeFromJSON(lastNodeJson);
      tr.replaceRangeWith(lastNodeStart, nodeEnd, newNode);
      editor.view.dom.blur();
      dispatch?.(tr);
      setTimeout(() => {
        const selectNodeNP = editor.$doc.querySelectorAll('paragraph', { id: uuid })[0]
        editor.commands.focus(selectNodeNP.from)
      }, 10);
      return true;
    }
  }catch (e){
    return false;
  }

  // 默认插入 orderedList 的行为
  return editor.commands.insertContent(`<ol><li><p></p></li></ol>`)
}
const insertIndentedTodoList=(editor,from,indent)=>{
  const state = editor.state;
  const dispatch = editor.view.dispatch;
  const { schema, tr, selection } = state;
  const rangeFrom = from;

  const resolvedPos = state.doc.resolve(rangeFrom);
  const nodeStart = resolvedPos.start(resolvedPos.depth);
  const nodeEnd = resolvedPos.end(resolvedPos.depth);

  const currentNode = resolvedPos.node();
  const parentNode = resolvedPos.node(resolvedPos.depth - 1);

  // 获取上一个相邻节点
  let lastNodeResolved;
  try {
    lastNodeResolved = state.doc.resolve(nodeStart - 2);
  } catch (error) {
    lastNodeResolved = undefined;
  }

  const lastNode = lastNodeResolved?.node();
  // 特殊情况：缩进 + 前面是 list，就做结构替换
  if (
      currentNode.type.name === 'paragraph' && indent &&
      indent >= 1 &&
      lastNodeResolved &&
      ['bulletList', 'orderedList', 'taskList'].includes(lastNode?.type.name)
  ) {
    let lastNodeJson = lastNode.toJSON();
    const uuid=crypto.randomUUID()

    // 构建新的子 list（bulletList -> listItem -> paragraph）
    const listItem = schema.nodes.taskItem.create({}, schema.nodes.paragraph.create({ id:uuid }));
    const taskList = schema.nodes.taskList.create({}, [listItem]);

    const lastNodeStart = lastNodeResolved.start(lastNodeResolved.depth);
    let firstLevelLastListItem = lastNodeJson.content[lastNodeJson.content.length - 1];

    firstLevelLastListItem.content.push(taskList.toJSON());
    lastNodeJson.content[lastNodeJson.content.length - 1] = firstLevelLastListItem;

    const newNode = schema.nodeFromJSON(lastNodeJson);
    tr.replaceRangeWith(lastNodeStart, nodeEnd, newNode);
    editor.view.dom.blur();
    dispatch?.(tr);
    setTimeout(() => {
      const selectNodeNP = editor.$doc.querySelectorAll('paragraph', { id: uuid })[0]
      editor.commands.focus(selectNodeNP.from)
    }, 10);
    return true;
  }

  // 默认插入 tasktList 的行为
  let todo = `<ul data-type="taskList"><li data-checked="false" data-type="taskItem"><label><input type="checkbox"><span></span></label><div><p></p></div></li></ul></div></li></ul>`
  return editor.commands.insertContent(todo)
}


export const defaultBlockMenuItems = (from)=>{
  const defaultMenu = [
    {
      name: "Text",
      keywords: "Text",
      view: commandView({
        name: t("Text"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_text',isDarkMode())+'\"'+"/>",
      }),
      command: (editor,from,indent) => editor.commands.insertContent(`<p></p>`),
      disable: (editor) => false,
    },
    {
      name: "H1",
      keywords: "H1",
      view: commandView({
        name: t("H1"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_head_1',isDarkMode())+'\"'+"/>",
      }),
      // command: (editor) => editor.commands.insertContent(`<h1></h1>`),
      command: (editor,from,indent) => editor.commands.setHeading({ level: 1 ,id:generateUUID2()}),
      disable: (editor) => false,
    },
    {
      name: "H2",
      keywords: "H2",
      view: commandView({
        name: t("H2"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_head_2',isDarkMode())+'\"'+"/>",
      }),
      // command: (editor) => editor.commands.insertContent(`<h2></h2>`),
      command: (editor,from,indent) => editor.commands.setHeading({ level: 2 ,id:generateUUID2()}),
      disable: (editor) => false,
    },
    {
      name: "H3",
      keywords: "H3",
      view: commandView({
        name: t("H3"),
        icon: '<img class=\'img-26 card-block-menu-image\'  src=\"'+getImagePathWithTheme('note_menu_head_3',isDarkMode())+'\"'+"/>",
      }),
      // command: (editor) => editor.commands.insertContent(`<h3></h3>`),
      command: (editor,from,indent) => editor.commands.setHeading({ level: 3 ,id:generateUUID2()}),
      disable: (editor) => false,
    },
      /*
    {
      name: "H4",
      keywords: "H4",
      view: commandView({
        name: t("H4"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_head_4')+'\"'+"/>",
      }),
      // command: (editor) => editor.commands.insertContent(`<h3></h3>`),
      command: (editor) => editor.commands.setHeading({ level: 4 }),
      disable: (editor) => false,
    },
    {
      name: "H5",
      keywords: "H5",
      view: commandView({
        name: t("H5"),
        icon: '<img class=\'img-26 card-block-menu-image\'  src=\"'+getImagePathWithTheme('note_menu_head_5')+'\"'+"/>",
      }),
      // command: (editor) => editor.commands.insertContent(`<h3></h3>`),
      command: (editor) => editor.commands.setHeading({ level: 5 }),
      disable: (editor) => false,
    },
    {
      name: "H6",
      keywords: "H6",
      view: commandView({
        name: t("H6"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_head_6')+'\"'+"/>",
      }),
      // command: (editor) => editor.commands.insertContent(`<h3></h3>`),
      command: (editor) => editor.commands.setHeading({ level: 6 }),
      disable: (editor) => false,
    },*/
    {
      name: "Card",
      keywords: "card",
      view: commandView({
        name: t("Card"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_card',isDarkMode())+'\"'+"/>"//Link({})
      }),
      command: async (editor,from,indent) =>{
        // window.showCardList();
        window.showPopupCardList(editor,false);
      },
      disable: (editor) => false,
      showInTemplate: false,
    },
    {
      name: "Todo",
      keywords: "todo",
      view: commandView({
        name: t("Todo"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_todo',isDarkMode())+'\"'+"/>"//List({}),
      }),
      command: (editor,from,indent) =>{
        // editor.chain().focus().toggleTaskList().run()
        // editor.can().splitListItem('taskItem')?editor.chain().focus().splitListItem('taskItem').run(): editor.chain().focus().toggleTaskList().run()
        let todo = `<ul data-type="taskList"><li data-checked="false" data-type="taskItem"><label><input type="checkbox"><span></span></label><div><p></p></div></li></ul></div></li></ul>`
        return insertIndentedTodoList(editor,from,indent)
      } ,
      disable: (editor) => false,
    },
    {
      name: "image",
      keywords: "img,picture,image",
      view: commandView({
        name: t("Image"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_image',isDarkMode())+'\"'+"/>"//Pic({}),
      }),
      command: async (editor,from,indent) => {

        window.showDialogChooseCardPdf(async (library:any)=>{
          //复制一个图片
          let szFileName = localStorage.getItem(KEY_FILE_DIR) + library.fileName;
          if (library.isAbsolutePath){
            szFileName = library.fileName;
          }

          // const imgId = crypto.randomUUID();
          const szExt = getFileNameExt(library.fileName);
          const imgId = await ipcInvoke('copy-file',{filePath:szFileName})

          editor.chain().focus().setImage({ src:`atom://${imgId}`}).createParagraphNear().run()
        },'image');

        // const imgId = crypto.randomUUID()
        // const img = await  ipcInvoke('save-img-by-id', imgId)
        // if(img){
        //   editor.chain().focus().setImage({ src:`atom://${imgId}.jpeg` }).createParagraphNear().run()
        // }
      },
      disable: (editor) => false,
      showInTemplate: false,
    },
    {
      name: "Link",
      keywords: "link",
      view: commandView({
        name: t("Link"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_link',isDarkMode())+'\"'+"/>"//Link({})
      }),
      command: async (editor,from,indent) =>{
        // @ts-ignore
        // let link = await window.GGetLink()
        // link && editor.commands.insertContent(` <a href='${link.link}' target="_self">${link.text}</a> `)

        window.showDialogCardLink(null,(link:any)=>{
          if(link===false)return
          if(!link.link.startsWith("http") && link.link.includes(".")){
            link.link=`https://${link.link}`
          }
          editor.commands.insertContent(` <a href='${link.link}' target="_blank">${link.text}</a> `);

          //这里处理所有链接？？？？
          setTimeout(()=>{
            window.hookATags();
          },500)
        })
      },
      disable: (editor) => false,
    },
    {
      name: "Bullet list",
      keywords: "img,picture,tp,zp,tx",
      view: commandView({
        name: t("Bullet list"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_bullet',isDarkMode())+'\"'+"/>"//ListBottom({}),
      }),
      // command: (editor) => editor.chain().focus().toggleBulletList().run(),
      // command: (editor) => editor.commands.insertContent(`<ul><li><p></p></li></ul>`),
      command: (editor,from,indent) => {
        return insertIndentedBulletList(editor,from,indent);
      },
      disable: (editor) => false,
    },
    {
      name: "Number list",
      keywords: "bulletList,unorderedList,wxlb",
      view: commandView({
        name: t("Number list"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_number',isDarkMode())+'\"'+"/>"//ListNumbers({}),
      }),
      // command: (editor) => editor.chain().focus().toggleOrderedList().run(),
      command: (editor,from,indent) => {
        return insertIndentedOrderedList(editor,from,indent);

      },
      disable: (editor) => false,
    },
    {
      name: "Quote",
      keywords: "Quote",
      view: commandView({
        name: t("Quote"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_quote',isDarkMode())+'\"'+"/>"//Quote({}),
      }),
      command: (editor,from,indent) => editor.chain().focus().toggleBlockquote().run(),
      disable: (editor) => false,
    },
    {
      name: "CodeBlock",
      keywords: "CodeBlock",
      view: commandView({
        name: t("CodeBlock"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_code',isDarkMode())+'\"'+"/>"
      }),
      // command: (editor) => editor.chain().focus().setHorizontalRule().run(),
      command: (editor,from,indent) =>editor.commands.insertContent(`<pre class="language-ts"><code></doce></pre>`),
      disable: (editor) => false,
    },
    {
      name: "Divider",
      keywords: "Divider",
      view: commandView({
        name: t("Divider"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_dividing',isDarkMode())+'\"'+"/>"//DividingLine({}),
      }),
      // command: (editor) => editor.chain().focus().setHorizontalRule().run(),
      command: (editor,from,indent) =>editor.commands.insertContent(`<hr/><p></p>`),
      disable: (editor) => false,
    },
    {
      name: "Table",
      keywords: "Table",
      view: commandView({
        name: t("Table"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_table',isDarkMode())+'\"'+"/>",
      }),
      command: (editor,from,indent) => editor.commands.insertTable({ rows: 2, cols: 2, withHeaderRow: false }),
      // command: (editor) =>editor.commands.insertContent(`<div class="tableWrapper"><table style="min-width: 50px;"><colgroup><col><col></colgroup><tbody><tr><td colspan="1"rowspan="1"><p><br class="ProseMirror-trailingBreak"></p></td><td colspan="1"rowspan="1"><p><br class="ProseMirror-trailingBreak"></p></td></tr><tr><td colspan="1"rowspan="1"><p><br class="ProseMirror-trailingBreak"></p></td><td colspan="1"rowspan="1"><p><br class="ProseMirror-trailingBreak"></p></td></tr><tr><div class="addRowIcon">123</div></tr></tbody></table></div>`),
      disable: (editor) => false,
    },
    {
      name: "Today",
      keywords: "Today",
      view: commandView({
        name: t("Today"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_today',isDarkMode())+'\"'+"/>"
      }),
      command: (editor,from,indent) => editor.commands.insertContent(`${getToday()}`),
      disable: (editor) => false,
    },
    {
      name: "Tomorrow",
      keywords: "Tomorrow",
      view: commandView({
        name: t("Tomorrow"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_tomorrow',isDarkMode())+'\"'+"/>"
      }),
      command: (editor,from,indent) => editor.commands.insertContent(`${getTomorrow()}`),
      disable: (editor) => false,
    },
    {
      name: "Now",
      keywords: "Now",
      view: commandView({
        name: t("Now"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_now',isDarkMode())+'\"'+"/>"
      }),
      command: (editor,from,indent) => editor.commands.insertContent(`${getNow()}`),
      disable: (editor) => false,
    },
    {
      name: "PDF",
      keywords: "Pdf",
      view: commandView({
        name: t("PDF"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_pdf',isDarkMode())+'\"'+"/>"
      }),
      command: (editor,from,indent) => {
        // window.showFileSelect("application/pdf",async (szImportMode:any,files:any)=>{
        //   const library:any = await insertFileToLibrary(szImportMode,files[0]);
        //   const szDeeplink = createCopyLink("library", library.id,library.type,null,null,null,false);
        //   setTimeout(()=>{
        //     insertDeeplinkToCard(szDeeplink,editor.view,editor.state.selection.from);
        //   },10)
        // })
        window.showDialogChooseCardPdf((library:any)=>{
          const szDeeplink = createCopyLink("library", library.id,library.type,null,null,null,false);
          setTimeout(()=>{
            insertDeeplinkToCard(szDeeplink,editor.view,editor.state.selection.from);
          },10)
        },'pdf');
      },
      disable: (editor) => false,
    },
    {
      name: "Video",
      keywords: "Video",
      view: commandView({
        name: t("Video"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_video',isDarkMode())+'\"'+"/>"
      }),
      command: (editor,from,indent) => {
        // window.showFileSelect("video/*",async (szImportMode:any,files:any)=>{
        //   const library:any = await insertFileToLibrary(szImportMode,files[0]);
        //   const szDeeplink = createCopyLink("library", library.id,library.type,null,null,null,false);
        //   setTimeout(()=>{
        //     insertDeeplinkToCard(szDeeplink,editor.view,editor.state.selection.from);
        //   },10)
        // })
        window.showDialogChooseCardPdf((library:any)=>{
          const szDeeplink = createCopyLink("library", library.id,library.type,null,null,null,false);
          setTimeout(()=>{
            insertDeeplinkToCard(szDeeplink,editor.view,editor.state.selection.from);
          },10)
        },'video');
      },
      disable: (editor) => false,
    },
    {
      name: "File",
      keywords: "File",
      view: commandView({
        name: t("File"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_file',isDarkMode())+'\"'+"/>"
      }),
      command: (editor,from,indent) => {
        // window.showFileSelect("*.*",async (szImportMode:any,files:any)=>{
        //   const library:any = await insertFileToLibrary(szImportMode,files[0]);
        //   const szDeeplink = createCopyLink("library", library.id,library.type,null,null,null,false);
        //   setTimeout(()=>{
        //     insertDeeplinkToCard(szDeeplink,editor.view,editor.state.selection.from);
        //   },10)
        // })
        window.showDialogChooseCardPdf((library:any)=>{
          const szDeeplink = createCopyLink("library", library.id,library.type,null,null,null,false);
          setTimeout(()=>{
            insertDeeplinkToCard(szDeeplink,editor.view,editor.state.selection.from);
          },10)
        },'file');
      },
      disable: (editor) => false,
    },
    {
      name: "Youtube",
      keywords: "Youtube",
      view: commandView({
        name: t("Youtube"),
        icon: '<img class=\'img-26 card-block-menu-image\'  src=\"'+getImagePathWithTheme('note_menu_youtube',isDarkMode())+'\"'+"/>"
      }),
      command: (editor,from,indent) => {
        let inputValue = '';
        function isValidYouTubeUrl(url) {
          // 正则匹配 YouTube 视频链接
          const regex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/(watch\?v=|embed\/|v\/|.+\?v=)?([a-zA-Z0-9_-]{11})(\S+)?$/;
          return regex.test(url);
        }
        const handleOk = () => {
          window.closeCommonInput();

          return new Promise((resolve, reject) => {
            if (isValidYouTubeUrl(inputValue)) {
              editor.commands.setYoutubeVideo({
                src: inputValue,
                width: '100%',
                height: Global.g_isDrawCardEditing?'220px':'350px',
              })
              resolve('success');
            } else {
              message.warning('This link is incorrect');
              reject('fail');
            }
          });
        };

        const handleKeyDown = (e) => {
          if (e.key === 'Enter') {
            handleOk()
                .then(() => {
                  Modal.destroyAll(); // 手动销毁弹窗
                })
                .catch(() => {
                });
          }
        };

        const handleCancel = () => {
          console.log('Cancelled');
        };

        postMessage(EVENT_SHOW_COMMON_INPUT,{name:'',title:t('Paste Youtube link'),callback:(szContent:any)=>{
          inputValue = szContent;
          handleOk()
        },placeHolder:t('Paste Youtube link')});

        // Modal.confirm({
        //   icon: null,
        //   content: React.createElement(Input, {
        //     onChange: (e) => inputValue = e.target.value,
        //     placeholder: 'Paste Youtube link',
        //     onKeyDown: handleKeyDown
        //   }),
        //   onOk: handleOk,
        //   onCancel: handleCancel,
        //   style: { top: '42%' }
        // });
      },
      disable: (editor) => false,
      showInTemplate: false,
    },
    {
      name: "Math block",
      keywords: "Math block",
      view: commandView({
        name: t("Math block"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_blockMath',isDarkMode())+'\"'+"/>"
      }),
      command: (editor,from,indent) => {
        editor.commands.insertContent(`<latex-block></latex-block>`)
      },
      disable: (editor) => false,
    },
    {
      name: "Inline math",
      keywords: "Inline math",
      view: commandView({
        name:  t("Inline math"),
        icon: '<img class=\'img-26 card-block-menu-image\' src=\"'+getImagePathWithTheme('note_menu_inlineMath.svg')+'\"'+"/>"
      }),
      command: (editor,from,indent) => {
        // editor.commands.insertContentAt(window.GEditor.state.selection.from, `$$`)
        // window.GEditor.commands.focus(window.GEditor.state.selection.from-2)
        editor.commands.insertContent(`<latex-inline data-firstCreate="true"></latex-inline>`)
        // editor.commands.insertContentAt(window.GEditor.state.selection.from - 2, `<latex-inline></latex-inline>`)
        // editor.commands.insertContent('--ooo--')
        // if(window.GEditor.state.selection.$from.parentOffset===0){
        //   console.log('行首');
        // }else{
        //   console.log('非行首');
        // }
      },
      disable: (editor) => false,
    },
    {
      name: "Template",
      keywords: "Template",
      view: commandView({
        name: t("Template"),
        icon: '<img class=\'img-26  card-block-menu-image\' src=\"' + getImagePathWithTheme('note_menu_template.svg') + '\"' + "/>"
      }),
      command: async (editor, from, indent) => {
        // 打开模板选择弹窗
        const selectedTemplate = await TemplateSelector.open();
        if (selectedTemplate && selectedTemplate.content) {
          // 清理模板内容中的装饰性元素（如列表折叠箭头、标题折叠箭头）
          // 这些元素是在 renderHTML 中动态添加的，不应该被保存或插入
          let cleanedContent = selectedTemplate.content;

          // 使用 DOMParser 清理 HTML
          const parser = new DOMParser();
          const doc = parser.parseFromString(cleanedContent, 'text/html');

          // 移除所有 list-image 和 heading-image 装饰性图片
          doc.querySelectorAll('img.list-image, img.heading-image').forEach(img => img.remove());

          // 获取清理后的 HTML
          cleanedContent = doc.body.innerHTML;

          // 在当前光标位置插入模板内容（保留原有格式）
          editor.commands.insertContent(cleanedContent);
        }
      },
      disable: (editor) => false,
      showInTemplate: false,
    }
  ];

  let arrayMenus = defaultMenu;
  if (isInSingleFloatWindow()){
    //移除 卡片，pdf,图片，视频，文件
    const arrayRemovedName = ['Card','image','PDF','Video','File'];
    arrayMenus = defaultMenu.filter(p=>!arrayRemovedName.includes(p.name));
  }

  if (from == 'stickynote'){
    //移除 卡片，pdf,图片，视频，文件
    const arrayRemovedName = ['Card','image','PDF','Video','File'];
    arrayMenus = defaultMenu.filter(p=>!arrayRemovedName.includes(p.name));
  }else if (from == 'templateEditor'){
    //移除 pdf,视频，文件
    const arrayRemovedName = ['PDF','Video','File'];
    arrayMenus = defaultMenu.filter(p=>!arrayRemovedName.includes(p.name));
  }

  return arrayMenus;
}

